import type {
  SizeProp,
} from "@fortawesome/fontawesome-svg-core";
import type { IconDefinition } from "@/icons/solid-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type { ComponentProps } from "react";

type FontAwesomeIconProps = ComponentProps<typeof FontAwesomeIcon>;

interface IIcon {
  icon: IconDefinition;
  className?: string;
  size?: SizeProp;
  id?: string;
  onClick?: () => void;
  style?: FontAwesomeIconProps["style"];
  inverse?: boolean;
  transform?: string;
}

const Icon: React.FC<IIcon> = ({
  icon,
  className,
  size,
  id,
  style,
  onClick,
  inverse = false,
  transform,
}) => {
  return (
    <FontAwesomeIcon
      icon={icon}
      id={id}
      data-testid={id}
      className={className}
      size={size}
      style={style}
      onClick={onClick}
      inverse={inverse}
      transform={transform}
    />
  );
};

export default Icon;
